import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

const FACILITY_USAGE_QUERY = gql(`
  query FacilityUsageQuery($chemicalId: ID!, $page: Int, $pageSize: Int, $includeItems: Boolean = false) {
      facilityUsage(chemicalId: $chemicalId, page: $page, pageSize: $pageSize) {
        facilityCount
        thisYearFacilityCount
        tenantCount
        items @include(if: $includeItems) {
          id
          name
          state
          streetAddress1
          streetAddress2
          city
          zip
          country
          reportingYears
          tenant {
            id
            name
          }
        }
      }
  }
`);

export function useFacilityUsage({
  chemicalId,
  page,
  pageSize,
  includeItems = false,
  skip = false,
}: {
  chemicalId: string;
  page?: number;
  pageSize?: number;
  includeItems?: boolean;
  skip?: boolean;
}) {
  return useQuery(FACILITY_USAGE_QUERY, {
    fetchPolicy: "cache-and-network",
    skip: skip || !chemicalId,
    variables: {
      chemicalId,
      includeItems,
      page: includeItems ? page : undefined,
      pageSize: includeItems ? pageSize : undefined,
    },
  });
}
